import React from "react";
import { Link } from "react-router-dom";

export type HomeItemData = {
  href: string;
  thumbnailSrc: string;
  title: string;
  subtitle?: string;
};

export function Item({ href, thumbnailSrc, title, subtitle }: HomeItemData) {
  return (
    <Link className="home-item" to={href} aria-label={title}>
      <img className="home-item-thumb" src={thumbnailSrc} alt={`${title} thumbnail`} />
      <div className="home-item-body">
        <div className="home-item-title">{title}</div>
        {subtitle ? <div className="home-item-subtitle">{subtitle}</div> : null}
      </div>
    </Link>
  );
}

export default Item;
